/* eslint prefer-template:0, no-underscore-dangle:0, no-multi-assign:0,
eqeqeq:0, camelcase:0, prefer-destructuring:0, no-mixed-operators:0
*/
import {
  log as Log,
  os,
  native,
} from '@ali/amap-lib';
import MsgBox from './msgbox';
import openAmap from './open-amap';
import link from '../../config/config.url';
import act from '../../config/config.act';
import $ from './zepto';

export default class Locate {
  constructor() {
    // ios10以下增加sessionStorage support
    try {
      window.sessionStorage.setItem('sessionStrorageSupport', '');
    } catch (err) {
      const session = window.sessionStorage;
      session.setItem = session.getItem = session.clear = session.removeItem = function f() {};
    }
    this.locationHistoryInit();
  }

  locationHistoryInit = () => {
    // 获取本地存储
    const _this = this;
    let {
      pathname
    } = window.location;
    if (pathname.search(/[\w-]+\.html/) < 0) {
      pathname += 'index.html';
    }
    _this.pathname = pathname;
    _this.StorageName = pathname.replace(/(page\/|\/)[\w-]+\.html/, '').replace(/(^\/|\/$)/g, '').replace(/\//g, '_');
    if (!_this.StorageName) {
      _this.StorageName = 'session_history';
    }
    if (!sessionStorage.getItem(_this.StorageName)) {
      sessionStorage.setItem(_this.StorageName, JSON.stringify([]));
    }
    _this.locationHistory = JSON.parse(sessionStorage.getItem(_this.StorageName) || null);
    _this.setlocationHistory();

    function checkReplace() {
      const pageName = _this.pathname.match(/\/([\w-]+)\.html/)[1];
      _this.locationHistory = JSON.parse(sessionStorage.getItem(_this.StorageName) || null) || [];
      let currentHistory = null;
      for (let len = _this.locationHistory.length, i = len - 1; i >= 0; i--) {
        if (pageName == _this.locationHistory[i].page) {
          currentHistory = _this.locationHistory[i];
          // if (currentHistory && currentHistory.isUpdate) {
          //   AMap.log.log('pv');
          //   $(window).trigger('updateData');
          // }
          _this.locationHistory.length = i;
          _this.locationHistory.push({
            page: pageName,
            isUpdate: false,
          });
          sessionStorage.setItem(_this.StorageName, JSON.stringify(_this.locationHistory));
          break;
        }
      }
      requestAnimationFrame(checkReplace);
    }

    if (os.ios) {
      requestAnimationFrame(checkReplace);
    }
  }

  /**
   *模拟a标签跳转
   *@param {string} url 要跳转的url
   *@param {Boolean} isReplace 是否替换当前页
   */
  locationRedirect = (url, isReplace) => {
    if (isReplace) {
      this.locationReplace(url);
    }
    if (os.ios) {
      let $lr = $('#locationRedirect');
      const ev = document.createEvent('MouseEvent');
      ev.initEvent('click', false, true);
      if ($lr.length) {
        $lr.attr('href', url);
      } else {
        $lr = $('<a id="locationRedirect" href="' + url + '" style="display:none;"></a>');
        $(document.body).append($lr);
      }
      $lr[0].dispatchEvent(ev);
    } else {
      window.location.href = url;
    }
  }

  /**
   * 修复iOS 9.0和9.1 下 replace后 再次跳转页面后调用back会回到前2个页面.
   * @param {String} url replace 的url
   */
  locationReplace = (url) => {
    if (os.ios && /^9\.[01]/.test(os.version)) {
      window.history.replaceState({}, null, url);
      window.location.reload();
    } else {
      window.location.replace(url);
    }
  }

  /**
   *  跳转页面（从历史记录）
   *  @param {string} url 要跳转的url
   *  @param {Boolean} isReplace 是否替换当前页
   */
  locationRedirectForHistory = (url, isReplace) => {
    const _this = this;
    if (!os.ios) _this.setlocationHistory();
    const locationHistory = _this.locationHistory || [];
    let step = 0;
    let redirectName = url.match(/([\w-]+)\.html(?:\?|#|$)/);
    if (!redirectName || redirectName[1] == locationHistory[locationHistory.length - 1]) {
      if (isReplace) {
        _this.locationReplace(url);
      }
      return false;
    }
    [redirectName] = redirectName;
    const len = locationHistory.length;
    for (let i = len - 2; i >= -1; i--) {
      step++;
      if (locationHistory[i] && redirectName == locationHistory[i].page) {
        locationHistory.length = i + 1;
        sessionStorage.setItem(_this.StorageName, JSON.stringify(locationHistory));
        break;
      }
    }
    if (step < len) {
      window.history.go(-step);
    }
    if (isReplace) {
      const page = (window.location.pathname.match(/([^/]+).html/) || ['', 'index'])[1];
      if (!(page == 'index' && window.location.hash && window.location.hash != '#/')) {
        if (locationHistory.length > 0) {
          locationHistory.length -= 1;
        }
        sessionStorage.setItem(_this.StorageName, JSON.stringify(locationHistory));
      }
      _this.locationReplace(url);
    } else {
      _this.locationRedirect(url);
    }
  }

  setlocationHistory = () => {
    const _this = this;
    const pageName = _this.pathname.match(/\/([\w-]+)\.html/)[1];
    const locationHistory = _this.locationHistory || [];
    for (let len = locationHistory.length, i = len - 1; i >= 0; i--) {
      if (pageName == locationHistory[i].page) {
        locationHistory.length = i;
        break;
      }
    }
    for (let len = locationHistory.length, i = 0; i < len; i++) {
      locationHistory[i].isUpdate = true;
    }
    locationHistory.push({
      page: pageName,
      isUpdate: false,
    });
    sessionStorage.setItem(_this.StorageName, JSON.stringify(locationHistory));
  }

  /**
   *  跳转页面
   *  @param {string} url 要跳转的url
   *  @param {Boolean} isReplace 是否替换当前页
   */
  pageJump = (url, isReplace) => {
    if (url.indexOf('//') != -1) { // 绝对路径&非项目内地址不计入历史记录
      this.locationRedirect(url, isReplace);
    } else {
      this.locationRedirectForHistory(url, isReplace);
    }
  }

  /**
   * [pageErr 接口错误跳error页面]
   * @param  {String} url  [aos url地址||actionname]
   * @param  {[type]} code [aos code||action出错则不传code]
   * @param  {boolean} onlytip 是否仅弹窗提示不跳转[默认false]
   */
  pageError = (url, code, onlytip) => {
    let inter;
    if (url.indexOf('/') != -1) {
      inter = url.match(/[^/]+\/[^/]+$/);
      inter = 'aos_' + (inter[0] ? inter[0].replace('/', '') : '');
    } else {
      inter = 'action_' + url;
      code = 999;
    }
    if (onlytip) {
      this.errorAlert(inter, code);
    } else {
      this.interError(inter, code);
    }
  }

  interError = (inter, code, onlytip) => {
    if (onlytip) {
      this.errorAlert(code, inter);
    } else {
      const currentUrl = window.location.href;
      let gd_from = currentUrl.match(/[^/]+$/) || [''];
      gd_from = gd_from[0].split('.')[0]; // 获取页面名称 拼在error.html上
      let url = 'error.html?code=' + code + '&inter=' + encodeURIComponent(inter || '');

      url += '&gd_from=' + gd_from;
      this.pageJump(url, true);
    }
  }

  errorAlert = (inter, code) => {
    let content;
    if (code < 0) {
      content = '网络无法连接，刷新一下';
    } else {
      content = '剁手的人太多了，刷新试试';
    }
    MsgBox({
      content,
      btns: [{
        text: '刷新',
        fun() {
          window.location.reload(true);
        }
      }]
    });
    Log.log('aoserror', {
      type: inter + '_' + code,
    });
  }

  /**
   * 去置入客户端的‘我的奖品’页面
   * @param activity 活动标识
   * @param isdetail 是否去详情页，默认false去列表页
   * @param awardid 奖品id,券id
   * @param coupon 券码
   * @param recordid 用户获奖id
   1. 当去列表页：所有参数不传，如果传activity则仅展示该活动标识下的奖品；
   2. 当去奖品详情页：activity、isdetail、awardid必传，否则去列表。
   如果传recordid则展现用户在此奖品下的获奖信息(如收货地址、券码等)
   */
  goAward = (activity, isdetail, awardid, coupon, recordid) => {
    let url = link.awardlist + '?gd_from=' + act.name;
    coupon = coupon || '';
    if (isdetail && activity && awardid) { // 详情页
      if (recordid) {
        url += '&act=' + activity + '&aid=' + awardid + '&rid=' + recordid + '#&detail-normal';
      } else if (coupon) {
        url += '&act=' + activity + '&aid=' + awardid + '&coupon=' + coupon + '#&detail-normal';
      } else {
        url += '&act=' + activity + '&aid=' + awardid + '#&detail-normal';
      }
    } else if (activity) {
        url += '&act=' + activity;
    }
    native.loadSchema(openAmap.getSchema(url, false, true));
  }

  /*
   * 去通用我的奖品过期列表
   *  @param activity 活动标识
   * */
  goOver = (activity) => {
    let url = link.awardlist + '?gd_from=' + act.name;
    if (activity) {
      url += '&act=' + activity + '#&overdue';
    }
    native.loadSchema(openAmap.getSchema(url, false, true));
  }

  /**
   * 去通用的‘编辑地址’页面
   * @param actname 活动标识
   */
  goAddr = (actname) => {
    if (!actname) return;
    const url = link.editaddr + '?gd_from=' + act.name + '&activity=' + actname;
    native.loadSchema(openAmap.getSchema(url, false, false));
  }

  routePlan = (type = 0, startPoi, endPoi) => {
    let schema = 'amapuri://route/plan?t=' + type;
    if (startPoi && startPoi.name && (startPoi.poiid || startPoi.x && startPoi.y)) {
      schema += '&sid=' + startPoi.poiid + '&slat=' + startPoi.y + '&slon=' + startPoi.x + '&sname=' + encodeURIComponent(startPoi.name);
    }
    if (endPoi && endPoi.name && (endPoi.poiid || endPoi.x && endPoi.y)) {
      if (endPoi.poiid) {
        schema += '&did=' + endPoi.poiid;
      } else {
        schema += '&dlat=' + endPoi.y + '&dlon=' + endPoi.x;
      }
      schema += '&dname=' + encodeURIComponent(endPoi.name);
    }
    // schema = 'amapuri://route/plan?t=3&did=B0FFG734TD&dname=%E9%A6%96%E5%BC%80%E5%B9%BF%E5%9C%BA';
    console.log(schema);

    native.loadSchema(schema);
  }
}
